import { useEffect } from 'react'
import apiClient from '@/api/client'
import { useAppSelector } from '@/store/hooks'
import { getAuthInfo } from '@/store/selectors/authSelector'
import { Dictionary } from '@/types/field'


const ConfigureApiClient = () => {
    const { token } = useAppSelector((state: Dictionary) => getAuthInfo(state))

    useEffect(() => {
        if (token) {
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
        } else {
            delete apiClient.defaults.headers.common['Authorization']
        }
    }, [token])
    return null
}

export default ConfigureApiClient
